import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import {
  STYLES,
  SYMBOLS,
  TEST_IDS,
  emptyString,
  NULL_DATA_HYPHEN,
} from "../../../constants";

export const ChangeComponent = ({
  result,
  isPercentageSign,
  isValueEqualToZero,
  isValueGreaterThanZero,
}) => {
  const commonSpan = (icon, className, text) => (
    <span className={className} data-testid={TEST_IDS.VALUE_CHANGE}>
      {icon ? (
        <FontAwesomeIcon icon={icon} className={STYLES.ICON_SPACING} />
      ) : (
        <></>
      )}
      {`${text}${isPercentageSign ? SYMBOLS.PERCENTAGE : emptyString}`}
    </span>
  );

  if (result) {
    if (isValueGreaterThanZero) {
      return commonSpan(faChevronUp, STYLES.TEXT_SUCCESS, result);
    } else if (isValueEqualToZero) {
      return commonSpan(emptyString, STYLES.TEXT_SECONDARY, result);
    } else {
      return commonSpan(faChevronDown, STYLES.TEXT_DANGER, result);
    }
  }

  return <span data-testid={TEST_IDS.VALUE_CHANGE}>{NULL_DATA_HYPHEN}</span>;
};
